module.exports = __webpack_public_path__ + "img/img_pc.d99387d4.png";